/**
 * "Good morning, Kalle." and the line under it, for the coach overview.
 *
 * The name is the first word of the signed-in name, and only when it is a
 * name: Auth0 falls back to the email address, and "Good morning,
 * kalle.s@gym.se" is worse than no name at all.
 */
export const greeting = (now: Date, name?: string | null): string => {
  const h = now.getHours();
  const part = h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
  const first = name && !name.includes('@') ? name.trim().split(/\s+/)[0] : '';
  return first ? `${part}, ${first}.` : `${part}.`;
};

/**
 * What is waiting, from the same counts the tiles and the queue show, so the
 * line can never disagree with the list under it.
 */
export const waitingLine = (
  counts: { toReview: number; targetsReached: number; quiet: number },
  options: { goals: boolean },
): string => {
  const parts = [
    counts.toReview ? `${counts.toReview} new ${counts.toReview === 1 ? 'scan' : 'scans'} to review` : null,
    options.goals && counts.targetsReached
      ? `${counts.targetsReached} ${counts.targetsReached === 1 ? 'target' : 'targets'} reached`
      : null,
    counts.quiet ? `${counts.quiet} gone quiet` : null,
  ].filter((p): p is string => p !== null);
  if (parts.length === 0) return 'Nothing waiting. Everyone is reviewed and scanning.';
  const sentence =
    parts.length === 1 ? parts[0] : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
  return `${sentence.charAt(0).toUpperCase()}${sentence.slice(1)}.`;
};
